/**
 * Utility functions for persisting the last selected view for each table in local storage
 */

const VIEW_STORAGE_PREFIX = 'last-view-';

/**
 * Save the last selected view ID for a specific table
 * @param listName - The table/list name (e.g., 'patients', 'tasks', 'users', 'internal-tasks')
 * @param viewId - The view ID to save, or null to clear
 */
export const saveLastViewId = (listName: string, viewId: number | null): void => {
    const storageKey = `${VIEW_STORAGE_PREFIX}${listName}`;

    if (viewId === null) {
        localStorage.removeItem(storageKey);
    } else {
        localStorage.setItem(storageKey, viewId.toString());
    }
};

/**
 * Retrieve the last selected view ID for a specific table
 * @param listName - The table/list name (e.g., 'patients', 'tasks', 'users', 'internal-tasks')
 * @returns The saved view ID, or null if none exists
 */
export const getLastViewId = (listName: string): number | null => {
    const storageKey = `${VIEW_STORAGE_PREFIX}${listName}`;
    const savedValue = localStorage.getItem(storageKey);

    if (savedValue === null) {
        return null;
    }

    const parsedValue = parseInt(savedValue, 10);
    return isNaN(parsedValue) ? null : parsedValue;
};

/**
 * Clear the last selected view ID for a specific table
 * @param listName - The table/list name (e.g., 'patients', 'tasks', 'users', 'internal-tasks')
 */
export const clearLastViewId = (listName: string): void => {
    saveLastViewId(listName, null);
};
